import { Auth } from "aws-amplify";
import { createOrderHistoryKey } from "../utils/Util";
import { setOrderHistoryMap } from "../utils/MapManager";

const URL = process.env.REACT_APP_ORDER_HISTORY_URL;

// サーバから購入履歴を取得する
const searchOrderHistory = async () => {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();

  const response = await fetch(URL, {
    headers: {
      Authorization: token,
      "Content-Type": "application/json",
    },
  }).catch((err) => {
    console.error(err);
  });

  if (!response?.ok) {
    console.error(response);
    return [];
  }

  return await response.json();
};

// 地図表示用に購入履歴マップを作成する
const createOrderHistoryMap = async (orderList) => {
  let resultMap = new Map();
  if (orderList && Array.isArray(orderList)) {
    orderList.forEach((item) => {
      // 複合キーを生成: "都道府県コードｰ市区町村名-大字名-丁目名-小字-予備-地番"
      const key = createOrderHistoryKey(item);
      const array = resultMap.get(key);
      if (array) {
        array.push(item);
        array.sort((a, b) => b.order_dt.localeCompare(a.order_dt));
        resultMap.set(key, array);
      } else {
        resultMap.set(key, [item]);
      }
    });
  }
  setOrderHistoryMap(resultMap);
};

// 購入履歴を取得し、マップを作成する
export const getOrderHistory = async () => {
  const orderList = await searchOrderHistory();
  await createOrderHistoryMap(orderList);
  return orderList;
};

// マップをクリアする
export const clearOrderHistoryMap = () => {
  setOrderHistoryMap(new Map());
};
